import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});

export const useMedicalHistoryDetailsAPI = () => {
  const [medicalHistory, setMedicalHistory] = useState([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (user_id: string) => {
      try {
        dispatch(
          setLoading({
            key: "isMedicalHistoryListInprogress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CUSTOMER_APIS?.MEDICAL_HISTORY_DETAILS?.baseURL}${user_id}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            dispatch(
              setLoading({
                key: "isMedicalHistoryListInprogress",
                status: false,
              }),
            );
            if (res.data.status) {
              setMedicalHistory(res.data.data);
            } else {
              setMedicalHistory([]);
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isMedicalHistoryListInprogress",
                status: false,
              }),
            );
            setMedicalHistory([]);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setMedicalHistory([]);
      }
    },
    [dispatch],
  );
  return { execute, medicalHistory };
};
